import { Component, OnInit } from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {ActivatedRoute} from '@angular/router';
import {RegisterService} from '../shared/services/register.service';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  token: string;
  newRegister = true;
  validToken = false;
  currentDate = new Date();
  constructor(private fb: FormBuilder, private registerService: RegisterService, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.registerService.checkToken(params.token).subscribe((r: boolean) => {
        this.validToken = r;
      });
      console.log('params: ' + params.token);
      this.newRegister = this.token === 'newRegister';
  }); }

  ngOnInit() {
   // this.token = this.route.snapshot.paramMap.get('token');
   // console.log(this.token);
   /* if (!this.newRegister) {
      this.registerService.checkToken(this.token).subscribe((r: boolean) => {
        this.validToken = r;
      });
    }*/
  }

}
